export default __webpack_public_path__ + "77f0a106e58b9ca13e52135dde2632a5.png";